/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A_Api_Baglantisi_NasilInputs */

const tr_faq_a_api_baglantisi_nasil = /** @type {(inputs: Faq_A_Api_Baglantisi_NasilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API anahtarını ilgili pazaryerinin satıcı panelinden alabilirsin. ShopPanel'deki Pazaryeri Bağlantıları sayfasında bu bilgileri girebilirsin.`)
};

const en_faq_a_api_baglantisi_nasil = /** @type {(inputs: Faq_A_Api_Baglantisi_NasilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get your API key from the marketplace's seller panel. Enter those details on ShopPanel's Marketplace Connections page.`)
};

const de_faq_a_api_baglantisi_nasil = /** @type {(inputs: Faq_A_Api_Baglantisi_NasilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Den API-Schlüssel erhältst du im Verkäufer-Panel des jeweiligen Marktplatzes. Diese Daten kannst du in ShopPanel auf der Seite Plattform-Verbindungen eingeben.`)
};

const ru_faq_a_api_baglantisi_nasil = /** @type {(inputs: Faq_A_Api_Baglantisi_NasilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-ключ можно получить в кабинете продавца соответствующей площадки. Введите эти данные на странице подключений в ShopPanel.`)
};

/**
* | output |
* | --- |
* | "Get your API key from the marketplace's seller panel. Enter those details on ShopPanel's Marketplace Connections page." |
*
* @param {Faq_A_Api_Baglantisi_NasilInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_a_api_baglantisi_nasil = /** @type {((inputs?: Faq_A_Api_Baglantisi_NasilInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A_Api_Baglantisi_NasilInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_a_api_baglantisi_nasil(inputs)
	if (locale === "de") return de_faq_a_api_baglantisi_nasil(inputs)
	if (locale === "ru") return ru_faq_a_api_baglantisi_nasil(inputs)
	return tr_faq_a_api_baglantisi_nasil(inputs)
});